import { observable, runInAction } from "mobx";

// Module-level cache of smartViewId → title. Populated by the sidebar list
// subscription so sync consumers (tab title/icon) can resolve names without
// running a Convex query themselves.
export const smartViewTitleCache = observable.map<string, string>({}, { deep: false });

export const setSmartViewTitles = (entries: { smartViewId: string; title: string }[]) => {
  runInAction(() => {
    // Don't `clear()` — chip resolution writes here for JIT/redirect ids that
    // aren't in the sidebar list, and we want those entries to survive a list
    // refresh. We only update entries from the list, leaving extras alone.
    for (const entry of entries) {
      smartViewTitleCache.set(entry.smartViewId, entry.title);
    }
  });
};

export const setSmartViewTitle = (smartViewId: string, title: string) => {
  runInAction(() => {
    smartViewTitleCache.set(smartViewId, title);
  });
};

export const getCachedSmartViewTitle = (smartViewId: string): string | undefined => {
  return smartViewTitleCache.get(smartViewId);
};
